import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CmsService,
  OccEndpointsService,
  RoutingService,
} from '@spartacus/core';
import { Subscription } from 'rxjs';
import { LeaveWebsitePopupComponent } from 'src/app/shared/modules/leave-website-popup/leave-website-popup/leave-website-popup.component';

@Component({
  selector: 'app-returns-page',
  templateUrl: './returns-page.component.html',
  styleUrls: ['./returns-page.component.scss'],
})
export class ReturnsPageComponent implements OnInit, OnDestroy {
  private readonly slotCompUid1: string =
    'sanofiPasteurExpiredReturnsGoodPDFComponent';
  private readonly slotCompUid2: string = 'pdfReservationGuideComponent';
  private readonly slotCompUid3: string =
    'sanofiReturnsProcessReferencePDFComponent';
  downloadRGIForm: string = '';
  downloadTnC: string = '';
  downloadrefGuide: string = '';
  private readonly baseUrl: string = '';
  cmsSub: Subscription;
  cmsSub2: Subscription;
  cmsSub3: Subscription;

  constructor(
    private readonly cmsData: CmsService,
    private readonly occEndPoint: OccEndpointsService,
    public modalService: NgbModal,
    private readonly route: RoutingService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit(): void {
    this.cmsSub = this.cmsData
      .getComponentData(this.slotCompUid1)
      .subscribe((res: any) => {
        this.downloadRGIForm = this.baseUrl + res?.document.url;
      });
    this.cmsSub2 = this.cmsData
      .getComponentData(this.slotCompUid2)
      .subscribe((res: any) => {
        this.downloadTnC = this.baseUrl + res?.document.url;
      });
    this.cmsSub3 = this.cmsData
      .getComponentData(this.slotCompUid3)
      .subscribe((res: any) => {
        this.downloadrefGuide = this.baseUrl + res?.document.url;
      });
  }
  ngOnDestroy(): void {
    this.cmsSub?.unsubscribe();
    this.cmsSub2?.unsubscribe();
    this.cmsSub3?.unsubscribe();
  }

  openPopup(link: string) {
    const modalRef = this.modalService.open(LeaveWebsitePopupComponent);
    modalRef.componentInstance.popup_title =
      'You are about to leave Sanofi US website';
    modalRef.componentInstance.externalUrl = link;
    modalRef.componentInstance.popup_content =
      'Sanofi does not review the information contained on this website and/or database for content, accuracy or completeness. Use of and access to this information is subject to the terms, limitations and conditions set by the website and/or database producer. Sanofi makes no representation as to the accuracy or any other aspect of the information contained on such website and/or database, nor does Sanofi necessarily endorse such website and/or database.';
  }

  //Methods below this not used as pdf not getting downloaed.Opening them in new tab only
  downloadRGForm() {
    this.fetchPdfAsBlob(this.downloadRGIForm).then((blob) => {
      const link = document.createElement('a');
      const fileURL = window.URL.createObjectURL(blob);
      link.href = fileURL;
      link.download = `SanofiPasteurExpiredReturnsGoodForm(Interactive).pdf`;
      link.target = '_blank';
      link.click();
      window.URL.revokeObjectURL(fileURL);
      link.remove();
    });
  }
  downlaodFile(fileLink: string) {
    const link = document.createElement('a');
    link.href = fileLink;
    link.target = '_blank';
    link.download = `SanofiPasteurExpiredReturnsGoodForm(Interactive).pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  fetchPdfAsBlob(pdfUrl) {
    return fetch(pdfUrl).then((response) => response.blob());
  }

  navigateToReturnPage() {
    this.route.goByUrl('/returns/view-return-form');
  }
}
